module.exports = __webpack_public_path__ + "img/stock4.ffef6da0.png";